import { gql } from '@apollo/client';

export default gql`
  query getRentitemsReport($itemIds: [String]) {
    getRentitemsReport(itemIds: $itemIds) {
      ok
      error
      data
      message
    }
  }
`;
